import frameworkUtils from 'utils/framework';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { happeningUserDataSelector } from 'selectors/page/happening/happeningUserDataSelector';

const { wrapHOC } = frameworkUtils;

const fields = createSelector(happeningUserDataSelector, user => ({ user }));

const functions = {};

const withHappeningUserProps = wrapHOC(connect(fields, functions));

export {
    withHappeningUserProps, fields, functions
};
